import React, { useEffect, useState } from "react";
import NewsCard from "../common/NewsCard";
import AdCard from "../common/AdCard";
import { getAdsForSection } from "../../config/ads";
import { Link } from "react-router-dom";

function NewsSection({ title, articles, category }) {
  const [masterArticle, setMasterArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadHomeMaster() {
      try {
        const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/homemasters`;
        const res = await fetch(apiUrl);
        const data = await res.json();

        const matched = data.find(
          (item) => item.HM_Section?.toLowerCase() === category?.toLowerCase()
        );

        setMasterArticle(matched || null);
      } catch (err) {
        console.error("HomeMaster API error:", err);
        setMasterArticle(null);
      } finally {
        setLoading(false);
      }
    }

    loadHomeMaster();
  }, [category]);

  if (!articles || articles.length === 0) {
    return (
      <div style={{ marginBottom: "35px" }}>
        <div className="ns-section-title">{title}</div>
        <p style={{ color: "#777", padding: "20px" }}>No articles available</p>
      </div>
    );
  }

  const bigCard = masterArticle || articles[0];
  const isMasterCard = !!masterArticle;

  const gridArticles = isMasterCard
    ? articles.slice(0, 12)
    : articles.slice(1, 13);

  const { ad1, ad2 } = getAdsForSection(category || title);

  return (
    <>
      <div style={{ marginBottom: "40px" }}>
        <div className="ns-section-title">{title}</div>

        {/* ================= ROW 1 ================= */}
        <div className="ns-row-1">
          <div className="ns-card ns-big-card">
            {isMasterCard ? (
              <Link
                to={`/homemaster/${bigCard.id}`}
                className="ns-big-card-link"
              >
                <BigCardContent bigCard={bigCard} isMasterCard />
              </Link>
            ) : (
              <BigCardContent bigCard={bigCard} isMasterCard={false} />
            )}
          </div>

          <div className="ns-ad-column">{ad1 && <AdCard ad={ad1} />}</div>
        </div>

        {/* ================= ROW 2 ================= */}
        <div className="ns-news-row">
          {gridArticles.slice(0, 4).map((article, i) => (
            <NewsCard key={`r2-${i}`} article={article} />
          ))}
        </div>

        {/* ================= ROW 3 ================= */}
        <div className="ns-news-row">
          {ad2 && <AdCard ad={ad2} />}
          {gridArticles.slice(4, 7).map((article, i) => (
            <NewsCard key={`r3-${i}`} article={article} />
          ))}
        </div>

        {/* ================= ROW 4 ================= */}
        <div className="ns-news-row">
          {gridArticles.slice(7, 11).map((article, i) => (
            <NewsCard key={`r4-${i}`} article={article} />
          ))}
        </div>
      </div>

      {/* ================= ALL STYLES ================= */}
      <style>{`
        /* Section Title */
        .ns-section-title {
          margin: 30px 0 10px;
          font-size: 22px;
          font-weight: bold;
          color: #1a1a1a;
        }

        /* Grid Layout */
        .ns-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
          gap: 15px;
        }

        /* Card Styles */
        .ns-card {
          background: #fff;
          border: none;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
          transition: transform 0.2s ease, box-shadow 0.2s ease;
          display: flex;
          flex-direction: column;
          height: 100%;
        }

        .ns-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
        }

        .ns-card img {
          width: 100%;
          height: 200px;
          object-fit: cover;
        }

        /* Content */
        .ns-content {
          padding: 12px;
          display: flex;
          flex-direction: column;
          flex-grow: 1;
        }

        /* Title Styles */
        .ns-title {
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 6px;
          color: #222;
          line-height: normal;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        /* Description Styles */
        .ns-desc {
          font-size: 14px;
          color: #555;
          margin-bottom: 8px;
          line-height: normal;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        /* Master Card Title */
        .ns-m-title {
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 6px;
          color: #222;
          line-height: normal;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        /* Master Card Description */
        .ns-m-desc {
          font-size: 18px;
          color: #555;
          margin-bottom: 8px;
          line-height: normal;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        /* Links */
        .ns-card a {
          color: #0066ff;
          font-size: 14px;
          font-weight: 600;
          text-decoration: none;
        }

        /* Meta Information */
        .ns-meta {
          margin-top: 8px;
          font-size: 12px;
          color: #777;
        }

        /* Row 1 Layout */
        .ns-row-1 {
          display: grid;
          grid-template-columns: 3fr 1fr;
          gap: 15px;
          margin-bottom: 15px;
        }

        .ns-big-card-link {
          text-decoration: none;
          color: inherit;
          height: 100%;
          display: block;
        }

        .ns-big-card-content {
          display: flex;
          height: 100%;
        }

        .ns-big-card-image {
          flex: 0 0 40%;
          min-height: 300px;
        }

        .ns-big-card-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .ns-big-card-body {
          padding: 20px;
          display: flex;
          flex-direction: column;
        }

        .ns-big-card-title {
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 12px;
          line-height: 1.4;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .ns-big-card-desc {
          font-size: 14px;
          color: #666;
          line-height: 1.6;
          -webkit-line-clamp: 4;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .ns-news-row {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 15px;
          margin-bottom: 15px;
        }

        /* ================= RESPONSIVE DESIGN ================= */

        /* Large Tablets and Small Desktops (1200px and below) */
        @media (max-width: 1200px) {
          .ns-news-row {
            grid-template-columns: repeat(2, 1fr) !important;
          }

          .ns-row-1 {
            grid-template-columns: repeat(2, 1fr) !important;
          }

          .ns-row-1 > div:first-child {
            grid-column: 1 / 3 !important;
          }

          .ns-row-1 > div:last-child {
            grid-column: 1 / 3 !important;
          }
        }

        /* Tablets (968px and below) */
        @media (max-width: 968px) {
          .ns-big-card > div {
            flex-direction: column !important;
          }

          .ns-big-card img {
            min-height: 200px !important;
          }
        }

        /* Small Tablets and Mobile (768px and below) */
        @media (max-width: 768px) {
          .ns-row-1 {
            grid-template-columns: 1fr;
          }

          .ns-big-card-content {
            flex-direction: column;
          }

          .ns-big-card-image {
            flex: 1;
            min-height: 200px;
          }

          .ns-news-row {
            grid-template-columns: 1fr 1fr;
          }
        }

        /* Mobile Phones (480px and below) */
        @media (max-width: 480px) {
          .ns-news-row,
          .ns-row-1 {
            grid-template-columns: 1fr !important;
          }

          .ns-row-1 > div:first-child,
          .ns-row-1 > div:last-child {
            grid-column: 1 / 2 !important;
          }
        }
      `}</style>
    </>
  );
}

/* ✅ Extracted component = cleaner + bug-free */
function BigCardContent({ bigCard, isMasterCard }) {
  return (
    <div className="ns-big-card-content">
      <div className="ns-big-card-image">
        <img
          src={isMasterCard ? bigCard.HM_Image : bigCard.image}
          alt={isMasterCard ? bigCard.HM_Title : bigCard.title}
        />
      </div>

      <div className="ns-big-card-body">
        <span style={{ fontSize: "13px", fontWeight: 600, color: "#0066cc" }}>
          {isMasterCard ? "BA News" : bigCard.source}
        </span>

        <div className="ns-big-card-title">
          {isMasterCard ? bigCard.HM_Title : bigCard.title}
        </div>

        <div className="ns-big-card-desc">
          {isMasterCard ? bigCard.HM_Description : bigCard.description}
        </div>

        {!isMasterCard && (
          <a
            href={bigCard.NewsSource || bigCard.link}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              marginTop: "10px",
              fontSize: "14px",
              color: "#0066cc",
              fontWeight: 500,
              textDecoration: "none",
            }}
          >
            Read More →
          </a>
        )}
      </div>
    </div>
  );
}

export default NewsSection;
